<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-10-31 17:55:03
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2024-12-26 15:53:28
 * @FilePath: \vue-hepha-order\src\views\base\OrderSource.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="priceContainer">
        <div class="queryPanel">
            <div class="queryPanel_form" :class="{'queryPanel_form_show': showForm}">
                <Form
                    :form="queryForm"
                    @handleSelectChange="handleSelectChange"
                    @handlePressEnter="handlePressEnter"
                    @handleInputClear=handleInputClear
                ></Form>
            </div>
            <div class="queryPanel_btn">
                <a-dropdown-button size="small" @click="handle('search')">
                    <icon-search size="14" style="marginRight:5px;"/>
                    {{ $t('base.search') }}
                    <template #content>
                        <a-doption @click="handle('reset')">
                            <icon-refresh size="14" style="marginRight:5px;"/>
                            {{ $t('base.reset') }}
                        </a-doption>
                    </template>
                </a-dropdown-button>
                <span class="openBtn" v-if="!showForm" @click="showFormPanel(true)">
                    <icon-down-circle size="14"/>
                    {{ $t('base.open') }}
                </span>
                <span class="openBtn" v-else @click="showFormPanel(false)">
                    <icon-up-circle size="14" />
                    {{ $t('base.close') }}
                </span>
            </div>
        </div>
        
        
        <Table
            :table="table"
            @changePage="changePage"
            @changePageSize="changePageSize"
        >
            <template v-slot:operate>
                <a-button type="primary" size="mini" v-permission="'setting.config.addAreaSaleManager'" @click="handle('create')">
                    <icon-plus-circle size="13" style="marginRight:5px;"/>
                    {{ $t('config.create') }}
                </a-button>
            </template>

            <template v-slot:tableOperate="{ props }">
                <a-button type="primary" status="danger" size="mini" v-permission="'setting.config.deleteAreaSaleManager'" @click="handle('delete', props.record)">
                    <icon-delete size="13" style="marginRight:5px;"/>
                    {{ $t('base.delete') }}
                </a-button>
            </template>
        </Table>

        <!-- 新增区域销售经理 -->
        <a-modal
            :title="t('config.create')"
            v-model:visible="visible" 
            width="30%"
            draggable
            :render-to-body="false"
            :onBeforeOk="onBeforeOk"
        >
            <Form
                :form="addAreaSaleManagerForm"
            ></Form>
        </a-modal>
    </div>
</template>

<script setup>
    import { nextTick, onMounted, reactive, ref, watch } from 'vue';
    import { BaseApi } from '@/api/BaseApi.js'; 
    import { OrderApi } from '@/api/OrderApi.js';
    import { DealerApi } from '@/api/DealerApi.js';
    import { Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import { QueryAreaSaleManagerForm, AddAreaSaleManagerForm } from './queryConfig/AddForm'
    import { useI18n } from 'vue-i18n';
    import { useLocale } from '@/store/index.js';
    import { dateToTimestamp, timestampToDate, formatterToPoint, formatterToComma, getNowDate, getWeek } from '@/utils/index.js';

    const { t } = useI18n()
    const localeStore = useLocale()

    const queryForm = reactive(QueryAreaSaleManagerForm)
    const addAreaSaleManagerForm = reactive(AddAreaSaleManagerForm)
    const visible = ref(false)
    const operateType = ref('add')
    const rowData = ref(null)
    const table = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'80',
                align:'center',
            },
            {
                // title: '销售',
                title:t('dealer.saleManager2'),
                dataIndex: 'dict_sub_name',
                key:'dict_sub_name',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '邮箱',
                title:t('base.email'),
                dataIndex: 'attribute1',
                key:'attribute1',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                title: t('base.operate'),
                dataIndex: 'Optional',
                key:'Optional',
                slotName:'optional',
                width: '160',
                align:'center',
                fixed:'right'
            }
        ],
        configs:{
            scroll:{
                // x:1000,
                y:480,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:{
                current:1,
                pageSize:20,
                total:0,
                pageSizeOptions:[10, 20, 50, 100],
                showJumper:true,
                showPageSize:true,
                showTotal:true,
            },
        },
    })

    const handle = (type,row)=>{
        switch(type){
            case 'search':
                table.value.configs.pagination.current = 1
                getList()
                break;
            case 'reset':
                for(let key in queryForm.formData){
                    queryForm.formData[key] = ''
                }
                table.value.configs.pagination.current = 1
                getList()
                break;
            case 'create':
                visible.value = true
                operateType.value = 'add'
                addAreaSaleManagerForm.formField.forEach(i=>{
                    addAreaSaleManagerForm.formData[i.key] = ''
                })
                break;
            case 'delete':
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    hideCancel:false,
                    content: t('base.delConfirmTip'),
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        delAreaSaleManager(row)
                    }
                });
                break;
        }
    }

    const showFormPanel = (val)=>{
        showForm.value = val
    }

    const search = (val)=>{
        table.value.configs.pagination.current = 1
        customer_name.value = val
        getList()
    }

    // 列表查询-input
    const handleInputClear = (val,item)=>{
        table.value.configs.pagination.current = 1
        getList()
    }
    const handlePressEnter = (val,item)=>{
        table.value.configs.pagination.current = 1
        getList()
    }

    const handleSelectChange = (val)=>{
        table.value.configs.pagination.current = 1
        getList()
    }

    const changePage = (current)=>{
        table.value.configs.pagination.current = current
        getList()
    }

    const changePageSize = (pageSize)=>{
        table.value.configs.pagination.current = 1
        table.value.configs.pagination.pageSize = pageSize
        getList()
    }

    // 获取区域销售经理列表
    const getList = async ()=>{
        let param = {
            dict_code: "dealer", 
            dict_sub_code:'sales_manager',
            dict_sub_name:queryForm.formData.dict_sub_name
        }
        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize
        table.value.configs.loading = true

        let res = await BaseApi.getInstance().getAreaSaleManagerList(param,page_num,page_size)
        if(res.code == 0){
            table.value.datas = []
            res.data.records.forEach((i,index)=>{
                table.value.datas.push({
                    ...i,
                    No:index + 1,
                    attribute1: !i.attribute1? '-' : i.attribute1,
                })
            })
            table.value.configs.pagination.total = res.data.total
            table.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 新增区域销售经理
    const onBeforeOk = async ()=>{
        let reg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        if(addAreaSaleManagerForm.formData.dict_sub_name == ''){
            Message.error(t('dealer.saleManager2') + ' ' + t('base.noEmpty'))
            return false
        }else if(addAreaSaleManagerForm.formData.attribute1 == ''){
            Message.error(t('base.email') + ' ' + t('base.noEmpty'))
            return false
        }else if(!reg.test(addAreaSaleManagerForm.formData.attribute1)){
            Message.error(t('customer.customerEmailFormatError'))
            return false
        }

        let param = {
            dict_code: "dealer", 
            dict_sub_code:'sales_manager',
            dict_sub_value:addAreaSaleManagerForm.formData.dict_sub_name,
            dict_sub_name:addAreaSaleManagerForm.formData.dict_sub_name,
            attribute1: addAreaSaleManagerForm.formData.attribute1,
        }
        let res = await BaseApi.getInstance().addAreaSaleManager(param)
        if(res.code == 0){
            Message.success(t('base.addSuccess'))
            getList()
        }else{
            Message.error(res.msg)
            return false
        }
    }

    // 删除区域销售经理
    const delAreaSaleManager = async (row)=>{
        let res = await BaseApi.getInstance().delAreaSaleManager(row.id)
        if(res.code == 0){
            Message.success(t('base.delSuccess'))
            getList()
        }else{
            Message.error(res.msg)
            return false
        }
    }

    // 处理查询面板伸缩时表格高度
    const resetTableHeight = (clientHeight)=>{
        const headerHeight = document.querySelector('.arco-layout-header').clientHeight
        const breadcrumbHeight = document.querySelector('.arco-page-header-with-breadcrumb').clientHeight
        // const searchContentDomHeight = document.querySelector('.queryPanel').clientHeight
        const pageHeight = 50
        const footerHeight = document.querySelector('.footer').clientHeight
        table.value.configs.scroll.y = clientHeight - headerHeight - breadcrumbHeight    - pageHeight - footerHeight - 100
    }

    watch(localeStore,(val)=>{
        resetTableHeight(val.clientHeight)
    })

    onMounted(async()=>{
        getList()

        nextTick(()=>{
            const clientHeight = document.body.clientHeight
            resetTableHeight(clientHeight)
        })
    })
</script>

<style lang="less" scoped>
.queryPanel{
    display: flex;
    // margin-bottom:7px;
    padding:7px;
    background: #fff;
    border-bottom: 1px dashed #ccc;

    .queryPanel_form{
        display: flex;
        flex:14;
        flex-direction: column;
        height: 33px;
        overflow: hidden;

        /deep/ .arco-form-layout-inline .arco-form-item{
            margin-bottom:0;
        }
    }

    .queryPanel_form_show{
        height: auto;
        overflow: visible;
    }

    .queryPanel_btn{
        display: flex;
        flex:1;
        // flex-direction: column;
        justify-content: center;
        align-items: center;
        border-left:1px solid #eee;
        padding-left:5px;

        .openBtn{
            display: inline-block;
            padding: 3px 10px;
            margin: 2px 5px 0 5px;
            width: 80px;
            text-align: center;
            color: #165dff;
            cursor: pointer;
            border: 1px solid #165dff;
            border-radius:2px;
        }
    }

    /deep/ .arco-form-item-label-col > .arco-form-item-label{
        font-size:12px;
    }

    .form_btn{
        margin:5px 5px 3px;
        width:70px;
    }
}

/deep/ .operayeBox {
    margin-bottom: 7px;
    background: #fff;
    padding: 5px 24px 5px;
}

/deep/ .arco-btn-group{
    vertical-align: bottom;
}
/deep/ .arco-btn-group .arco-btn:first-child,
/deep/ .arco-btn-group .arco-btn:last-child{
    background: #165dff;
    color: #fff;
}

/deep/ .arco-picker-size-medium input,
/deep/ .arco-input-wrapper .arco-input.arco-input-size-medium,
/deep/ .arco-select-view-single.arco-select-view-size-medium .arco-select-view-input{
    font-size:12px;
}

/deep/ .arco-modal-body{
    text-align: center !important;
}

/deep/ .arco-table-th{
    background: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    padding: 3px 0;
    font-weight: 600;
}

/deep/ .arco-table-td{
    padding: 0;
    // border-bottom: none;
    border-right: 1px solid #eee;
}

/deep/ .arco-table-container{
    padding-bottom:0;
}

/deep/ .arco-pagination-options .arco-select,
/deep/ .arco-pagination-jumper .arco-pagination-jumper-input input{
    background: #e7e7e7;
}

/deep/ .arco-input-wrapper .arco-input[disabled] {
    -webkit-text-fill-color: #999;
}

/deep/ .arco-form-item-label-col{
    width:0 !important;
}

/deep/ button:focus, button:focus-visible{
    outline:none;
}
</style>